module.exports = __webpack_public_path__ + "img/icon_blogs.397876d1.svg";